import { NextArticlePath } from 'src/api/article/dataArticle';
import ArticleSection from 'src/components/LandingPage/ArticleSection';
import AudioContentCard from 'src/components/AudiocontentDetail/AudioContentCard';
import AudiocontentHelpers from 'src/components/AudiocontentDetail/Layout/AudioContentHelpers';
import Footer from 'src/components/Common/Footer';
import Helpers from 'src/components/LandingPage/Layout/LandingPageHelpers';
import LettersIndex from 'src/components/AudiocontentDetail/LettersIndex';
import MoreToLearn from 'src/components/AudiocontentDetail/MoreToLearn';
import NavBar from 'src/components/Common/NavBar';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { AudioDetail } from 'src/api/audioContent/audioContent.graphql';

type AudioContentDetailLayoutProps = {
  articles: NextArticlePath[];
  audiodetail: AudioDetail;
};

const SectionContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const AudioContentDetailLayout = (
  props: AudioContentDetailLayoutProps
): JSX.Element => {
  const { articles, audiodetail } = props;
  const audioContentData = AudiocontentHelpers.getAudiocontentData(audiodetail);
  const dataLearnMore = AudiocontentHelpers.getMoreToLearnData(audiodetail);
  const dataArticleSection = Helpers.getDataArticleSection(articles);
  return (
    <>
      <NavBar />
      <AudioContentCard book={audioContentData} />
      {!audiodetail.audio?.avoidSeoIndex && (
        <>
          <MoreToLearn {...dataLearnMore} />
          <LettersIndex />
          <SectionContainer>
            <ArticleSection type="audioContent" data={dataArticleSection} />
          </SectionContainer>
          <Footer marginTopDesktop="12.5rem" marginTopMobile="5.5rem" />
        </>
      )}
    </>
  );
};
export default AudioContentDetailLayout;
